(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muriclyn-home-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mrc-routine-carousel')) {
    customElements.define('mrc-routine-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.mrc-home__steps');
        this.slides = [...this.querySelectorAll('.mrc-home__step')];
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.position = this.querySelector('[data-position]');
        if (!this.track || !this.slides.length) return;
        this.querySelector('.mrc-home__carousel-controls').hidden = false;
        this.previous.addEventListener('click', () => this.go(this.index - 1), options);
        this.next.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('keydown', event => {
          const destinations = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in destinations)) return;
          event.preventDefault();
          this.go(destinations[event.key]);
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      update() {
        const first = this.slides[0].offsetLeft;
        this.index = this.slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - first - this.track.scrollLeft) < Math.abs(this.slides[best].offsetLeft - first - this.track.scrollLeft) ? index : best, 0);
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        const label = this.dataset.label.replace('{current}', this.index + 1).replace('{total}', this.slides.length);
        if (this.position.textContent !== label) this.position.textContent = label;
      }
      go(index) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: this.slides[target].offsetLeft - this.slides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nourish-faq"] && !Shopify.designMode) return;
  try {
    /* nourish-behaviour:fg-faq */
(function(){if(true)try{(function(){function initFaq(root){var items=root.querySelectorAll("[data-fgfaq-item]");items.forEach(function(item){var summary=item.querySelector("summary"),wrap=item.querySelector(".fgfaq__a-wrap");!summary||!wrap||summary.addEventListener("click",function(e){if(e.preventDefault(),item.hasAttribute("open")){var done=function(ev){ev&&ev.propertyName!=="grid-template-rows"||(item.removeAttribute("open"),item.classList.remove("is-collapsing"),wrap.removeEventListener("transitionend",done))};wrap.addEventListener("transitionend",done),item.classList.add("is-collapsing")}else items.forEach(function(other){other!==item&&(other.removeAttribute("open"),other.classList.remove("is-collapsing"))}),item.setAttribute("open","")})})}function initAll(){for(var sections=document.querySelectorAll(".fgfaq"),i=0;i<sections.length;i++)initFaq(sections[i])}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",initAll):initAll()})()}catch(e){console.error(e)}})();

  } catch(e) { console.error(e); }
})();
})();
